import React from 'react'
import {Sort} from '@components/common/base/sort'
import {
  TwTableHeadCell,
  TwTableHeadSort
} from '@components/common/base/table/containers'
import {tableSortStateToSort} from '@components/common/base/table/utils'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {TableSortState} from './types'

export interface TableHeadCellProps {
  children: React.ReactNode
  sortState?: TableSortState
  onClick?: () => void
  width?: number | string | 'none'
  minWidth?: number | string
  maxWidth?: number | string
  className?: string
  oldSortStyle?: boolean
  name?: string
  showTooltip?: boolean
}

export const TableHeadCell = (props: TableHeadCellProps) => {
  const {
    children,
    onClick,
    width,
    minWidth,
    maxWidth,
    className,
    sortState = 'disabled',
    name,
    showTooltip = false
  } = props

  return (
    <Tooltip disabled={!showTooltip || !name} offset={[0, 0]} content={name}>
      <TwTableHeadCell
        style={{
          width: getWidthValue(width),
          minWidth: getWidthValue(minWidth),
          maxWidth: getWidthValue(maxWidth)
        }}
        onClick={onClick}
        $disabled={!onClick || sortState === 'disabled'}
        className={className}
        $active={sortState === 'up' || sortState === 'down'}
      >
        {children}
        {sortState !== 'disabled' && (
          <TwTableHeadSort>
            <Sort state={tableSortStateToSort(sortState)} />
          </TwTableHeadSort>
        )}
      </TwTableHeadCell>
    </Tooltip>
  )
}

const getWidthValue = (
  width: undefined | string | number | 'none'
): string | number | undefined => {
  if (width === undefined) {
    return 'auto'
  }

  if (width === 'none') {
    return undefined
  }

  return width
}
